__turbopack_context__.v({
  "className": "grotesk_abda080e-module__H-DonG__className",
  "variable": "grotesk_abda080e-module__H-DonG__variable",
});
